import { Injectable } from '@angular/core';
import Dexie from 'dexie';

@Injectable({
  providedIn: 'root',
})
export class IndexDbStorageService extends Dexie {
  private readonly cockpitStore: Dexie.Table<any, string>; // Specify the table structure

  constructor() {
    super('CockpitDB'); // Initialize the database with a name

    // Define the database schema
    this.version(1).stores({
      cockpitStore: 'key', // 'key' will act as the primary key
    });

    // Get a reference to the table
    this.cockpitStore = this.table('cockpitStore');
  }

  // Save item
  async setItem<T>(key: string, value: T): Promise<void> {
    await this.cockpitStore.put({ key, value });
  }

  // Get item
  async getItem<T>(key: string): Promise<T | null> {
    const record = await this.cockpitStore.get(key);
    return record ? (record.value as T) : null;
  }

  // Remove item
  async removeItem(key: string): Promise<void> {
    await this.cockpitStore.delete(key);
  }

  // Clear all data
  async clear(): Promise<void> {
    await this.cockpitStore.clear();
  }

  // Get all keys
  async keys(): Promise<string[]> {
    const records = await this.cockpitStore.toArray();
    return records.map((record) => record.key);
  }
}
